module.exports = __webpack_public_path__ + "static/media/cryptokek.05a322c8.png";